import React, { Component } from "react";
import { BiSolidDashboard } from "react-icons/bi";
import { Col, Row } from "reactstrap";
import TriviaLibrary from "./LibraryModule/TriviaLibraryListPage";
import MyPendingTrivvys from "./MyPendingTrivvys";
import MyKnowledgeChecks from "./MyKnowledgeChecks";
import MyMessages from "../../components/MyMessages/MyMessages";

import TriviaList from "./TriviaList";
import TriviaKCSList from "./TriviaKCSList";
import * as url from "../../utils/url";
import * as actionCreators from "../../modules/actions/index";
import Loading from "../../hoc/Loading/Loading";
import axios from "../../axios";
import { connect } from "react-redux";
import MyTrivia from "./MyTrivia";
import TriviaRewards from "./TriviaRewards";
import { Redirect, Route, Switch } from "react-router";
import { isTrivvyProduct, TRIVIA_DESCRIPTION, Spinner } from "../../utils/constants";
import ReactTooltip from "react-tooltip";
import { isIphone, isMobile } from "../../utils/deviceInfo";

import OfficeMateProfile from "../../pages/office/OfficeMateProfile/OfficeMateProfile";

import RewardCreateModal from "./Components/RewardCreateModal";
import "./trivia-survey.css";
import TriviaLibraryViewPage from "./LibraryModule/TriviaLibraryViewPage";
import { toastContainer } from "../../utils/toast";
import TriviaMessages from "./TriviaMessages";
import TriviaBreakingNewsTab from "./TriviaBreakingNews";
import UserChatsPage from "./UserChats/UserChatsPage";
class TriviaContainer extends Component {
  constructor(props) {
    super(props);

    const isOrgAdmin = !!(props.user && props.user.profile && props.user.profile.orgAdmin);

    var isAdminUser = isOrgAdmin || (props.user && props.user.profile && props.user.profile.role == "Admin");
    this.state = {
      tab: 1,
      rewardUpdatedDataForTrivvy: {
        rewardId: null,
        trivvyIds: [],
      },
      triviaModalOpen: false,
      hasUserChatAccess: isOrgAdmin,
      resolvingDefaultTab: !isAdminUser,
    };
  }

  updateTab = () => {
    const pathname =
      (this.props.location && this.props.location.pathname) || "";

    const endPathArr = pathname.split("/");

    const endPath = endPathArr[endPathArr.length - 1];

    console.log(endPathArr);

    if (endPath.indexOf("kcs-list") > -1) {
      this.setState({ tab: 6 });
    } else if (endPath.indexOf("list") > -1) {
      this.setState({ tab: 2 });
    } else if (endPath.indexOf("breaking-news") > -1) {
      this.setState({ tab: 0 });
    }
    // else if (endPath.indexOf("pending-trivvys") > -1) {
    //   this.setState({ tab: 1 });
    // }

    else if (pathname.indexOf("/user-chats") > -1) { // bug903: full pathname, not just last segment
      this.setState({ tab: 10 });
    } else if (endPath.indexOf("library") > -1) {
      this.setState({ tab: 3 });
    } else if (endPath.indexOf("rewards") > -1) {
      this.setState({ tab: 4 });
    } else if (endPath.indexOf("my-surveys") > -1) {
      this.setState({ tab: 7 });
    } else if (endPath.indexOf("my-messages") > -1) {
      this.setState({ tab: 8 });
    } else if (endPath.indexOf("my-knowledge-checks") > -1) {
      this.setState({ tab: 9 });
    } else if (endPath.indexOf("messages") > -1) {
      this.setState({ tab: 5 });
    }
  };

  componentWillReceiveProps(nextProps) {
    this.updateTab();
  }

  componentDidMount() {
    const isAdmin =
      this.props.user.profile.orgAdmin ||
      this.props.user.profile.role == "Admin";
    let that = this;
    let orgId = this.props.user.profile.organizationId._id;

    axios.get(url.findOrgById(orgId)).then(({ data }) => {
      const payload = data.data;
      that.props.orgChangeSuccess(payload);
    });
    if (isAdmin) {
      this.setState({ loading: true });
    }
      // For non-admin users on initial login, determine default landing tab based on pending content
      if (!isAdmin) {
        axios.get(url.getMyPendingTrivvys)
          .then(function(response) {
            var data = response.data && response.data.data;
            var defaultTab = 'library';
            // Double check: only consider items that are truly pending
            var pendingData = data ? data.filter(function(t) { return t.isPending === true; }) : [];
            if (pendingData.length > 0) {
              var hasSurveys = pendingData.some(function(t) {
                return t.triviaId && t.triviaId.triviaCategoryType === 'SURVEY' && !t.triviaId.isMessaging;
              });
              var hasMessages = pendingData.some(function(t) {
                return t.triviaId && t.triviaId.isMessaging;
              });
              var hasKCs = pendingData.some(function(t) {
                return t.triviaId && t.triviaId.triviaCategoryType === 'KNOWLEDGE_CHECK';
              });

              if (hasSurveys) {
                defaultTab = 'my-surveys';
              } else if (hasMessages) {
                defaultTab = 'my-messages';
              } else if (hasKCs) {
                defaultTab = 'my-knowledge-checks';
              }
            }
            that.props.history.replace(that.props.match.url + '/' + defaultTab);
            that.setState({ resolvingDefaultTab: false });
          })
          .catch(function(err) {
            console.log('Error checking user content for default tab:', err);
            that.props.history.replace(that.props.match.url + '/library');
            that.setState({ resolvingDefaultTab: false });
          });
      }
      // For non-admin users, also update tab based on current URL
      this.updateTab();

    this.props.handleGlobalRewardModal({
      open: false,
      trivvys: [],
    });
    if (
      isTrivvyProduct() &&
      window.location.pathname.indexOf(
        `/trivia/${this.props.user.profile.organizationId._id}/list`
      ) > -1
    ) {
      axios
        .get(url.getMyPendingTrivvys)
        .then(({ data }) => {
          if (data.data.length) {
            this.props.updateUserSuccess({
              ...this.props.user.profile,
              pendingTrivvysCount: data.data.length,
            });

            if (!this.props.user.hidePendingTrivvyToast) {
              toastContainer(
                // <div  onClick={() => {
                //   this.props.history.push(
                //     `/home/${this.props.user.profile.organizationId._id}/profile/${this.props.user.profile._id}/pending-trivvys`
                //   );
                // }}>
                //   You have trivvys pending, Please click{" "}
                //   <b

                //   >
                //     here
                //   </b>{" "}
                //   to view{" "}
                // </div>,
                "Please click on your pending Trivvy to take it.",
                "success"
              );

              this.props.updateUserSuccess({
                ...this.props.user.profile,
                hidePendingTrivvyToast: true,
              });
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  changeTab = (number) => {
    const baseUrl = this.props.match.url;
    if (number === 0) {
      this.props.history.push(`${baseUrl}/breaking-news`);
    }
    if (number === 3) {
      this.props.history.push(`${baseUrl}/library`);
    }
    if (number === 2) {
      this.props.history.push(`${baseUrl}/list`);
    }
    if (number === 10) {
      this.props.history.push(`${baseUrl}/user-chats`);
    }
    // if (number === 1) {
    //   // this.props.history.push("my-trivia");
    //   this.props.history.push(`${baseUrl}/pending-trivvys`);
    // }
    if (number === 4) {
      this.props.history.push(`${baseUrl}/rewards`);
    }
    if (number === 5) {
      this.props.history.push(`${baseUrl}/messages`);
    }
    if (number === 6) {
      this.props.history.push(`${baseUrl}/kcs-list`);
    }
    if (number === 7) {
      this.props.history.push("my-surveys");
    }
    if (number === 8) {
      this.props.history.push("my-messages");
    }
    if (number === 9) {
      this.props.history.push("my-knowledge-checks");
    }
  };

  updateLibraryList = (list) => {
    this.setState({ libraryList: list });
  };

  handleDataUpdate = (reward) => {
    this.setState({
      rewardUpdatedDataForTrivvy: {
        rewardId: reward._id,
        trivvyIds: reward.linkedTrivias.map((x) => x.triviaId),
      },
    });
  };

  openCreateTrivvy = () => {
    this.props.handleGlobalRewardModal({
      open: false,
      trivvys: [],
    });
    this.setState({
      triviaModalOpen: true,
    });
  };
  render() {
    const { tab, rewardUpdatedDataForTrivvy } = this.state;
    const isAdmin =
      this.props.user.profile.orgAdmin ||
      this.props.user.profile.role == "Admin";

    const {
      rewardModalOpen,
      rewardModalPreselectedTrivvys,
      handleGlobalRewardModal,
      TriviaBreakingNews,
    } = this.props;

    const planType = this.props.user.profile.organizationId.trivvyPlanType;

    const isSurveySamplesPage =
      window &&
      window.location &&
      window.location.pathname &&
      window.location.pathname.indexOf("survey-samples") >= 0;

    if (this.state.resolvingDefaultTab) {
      return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '300px' }}>
          <img src={Spinner} alt="Loading..." />
        </div>
      );
    }

    return (
      <div
        className="bwai-chrome-page"
        style={{
          ...(isIphone && {
            marginTop: "30px",
          }),
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
          className="trivia-container-top-div bwai-chrome-tabs"
        >
          {/* <div>
            <BiSolidDashboard size={50} />
          </div> */}
          <div style={{ flex: 1 }}>
            {/* <span
              style={{
                fontWeight: "bold",
              }}
              className="top-trivia-page-container"
            >
              My <span data-tip={TRIVIA_DESCRIPTION}>Trivvy</span> Space
            </span> */}
            <ReactTooltip />

            <div>
              <div 
                className="top-trivia-results-row" 
                style={{
                  ...(isMobile && {
                    overflowX: "auto",
                    overflowY: "hidden",
                    WebkitOverflowScrolling: "touch",
                    display: "block",
                    whiteSpace: "nowrap",
                    maxWidth: "100vw"
                  })
                }}
              >
                <ul 
                  className="data-user trivia-tabs trivia-main-tabs" 
                  style={{ 
                    width: "max-content",
                    ...(isMobile && {
                      display: "inline-flex",
                      marginBottom: 0
                    })
                  }}
                >
                  <li style={{ position: "relative" }}>
                    <a
                      className={`${tab == 0 ? "profile_page_menu_option_active" : ""
                        }`}
                      onClick={() => this.changeTab(0)}
                    >
                      Newsfeed
                    </a>
                  </li>
                  {/* {this.state.hasUserChatAccess && ( */}
                    <li style={{ display: this.state.hasUserChatAccess ? "inline-table" : "none" }}>
                      <a
                        className={`${tab == 10 ? "profile_page_menu_option_active" : ""
                          }`}
                        onClick={() => this.changeTab(10)}
                      >
                        User Chats
                      </a>
                    </li>
                  {/* )} */}
                  {/* <li style={{ position: "relative" }}>
                    <a
                      className={`${
                        tab == 1 ? "profile_page_menu_option_active" : ""
                      }`}
                      onClick={() => this.changeTab(1)}
                    >
                      Pending {isMobile ? "" : "Trivvys"}
                    </a>
                    {this.props.user.profile.pendingTrivvysCount > 0 && (
                      <span className="pending_trivvys_tab_count">
                        {this.props.user.profile.pendingTrivvysCount}
                      </span>
                    )}
                  </li> */}
                  
               {isAdmin && (
                    <li style={{ display: isAdmin ? "inline-table" : "none" }}>
                    <a
                      className={`${
                        tab == 2 ? "profile_page_menu_option_active" : ""
                      }`}
                      onClick={() => this.changeTab(2)}
                    >
                      Surveys
                    </a>
                  </li>
               )}
                    {isAdmin && (
                    <li style={{ display: isAdmin ? "inline-table" : "none" }}>
                    <a
                      className={`${
                        tab == 5 ? "profile_page_menu_option_active" : ""
                      }`}
                      onClick={() => this.changeTab(5)}
                    >
                      Messages
                    </a>
                  </li>
                    )}

                  {isAdmin && (
                    <li style={{ display: isAdmin ? "inline-table" : "none" }}>
                    <a
                      className={`${
                        tab == 6 ? "profile_page_menu_option_active" : ""
                      }`}
                      onClick={() => this.changeTab(6)}
                    >
                      Knowledge Checks
                    </a>
                  </li>
                   )}
                   {!isAdmin && (
                    <li style={{ display: !isAdmin ? "inline-table" : "none" }}>
                    <a
                      className={`${
                        tab == 7 ? "profile_page_menu_option_active" : ""
                      }`}
                      onClick={() => this.changeTab(7)}
                    >
                      Surveys
                    </a>
                  </li>
                   )}
                   {!isAdmin && (
                    <li style={{ display: !isAdmin ? "inline-table" : "none" }}>
                    <a
                      className={`${
                        tab == 8 ? "profile_page_menu_option_active" : ""
                      }`}
                      onClick={() => this.changeTab(8)}
                    >
                      Messages
                    </a>
                  </li>
                   )}
                   {!isAdmin && (
                    <li style={{ display: !isAdmin ? "inline-table" : "none" }}>
                    <a
                      className={`${
                        tab == 9 ? "profile_page_menu_option_active" : ""
                      }`}
                      onClick={() => this.changeTab(9)}
                    >
                      Knowledge Checks
                    </a>
                  </li>
                   )}
                  <li>
                    <a
                      className={`${
                        tab == 3 ? "profile_page_menu_option_active" : ""
                      }`}
                      onClick={() => this.changeTab(3)}
                    >
                      Library
                    </a>
                  </li>
{/* 
                  {planType != "001" && (
                    <li style={{ display: isAdmin ? "inline-table" : "none" }}>
                      <a
                        className={`${
                          tab == 4 ? "profile_page_menu_option_active" : ""
                        }`}
                        onClick={() => this.changeTab(4)}
                      >
                        Rewards
                      </a>
                    </li>
                  )} */}
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-3">
          {rewardModalOpen && (
            <RewardCreateModal
              open={rewardModalOpen}
              preSelectedTriviaIds={rewardModalPreselectedTrivvys}
              onClose={() => {
                handleGlobalRewardModal({
                  open: false,
                  trivvys: [],
                });
              }}
              history={this.props.history}
              addDataInRow={this.handleDataUpdate}
              openCreateTrivvy={this.openCreateTrivvy}
            />
          )}

          <Switch>
                {isAdmin && (
            <Route exact path={this.props.match.url + "/list"}>
              <TriviaList
                className="trivvy-list-trivvy-container"
                updateTrivvyLinkedRewards={rewardUpdatedDataForTrivvy}
                trivvyOpen={this.state.triviaModalOpen}
                setTrivvyOpen={(v) => this.setState({ triviaModalOpen: v })}
                isAdmin={isAdmin}
                {...this.props}
              />
            </Route>
                )}

                {isAdmin && (
            <Route exact path={this.props.match.url + "/kcs-list"}>
              <TriviaKCSList
                className="trivvy-list-trivvy-container"
                updateTrivvyLinkedRewards={rewardUpdatedDataForTrivvy}
                trivvyOpen={this.state.triviaModalOpen}
                setTrivvyOpen={(v) => this.setState({ triviaModalOpen: v })}
                isAdmin={isAdmin}
                {...this.props}
              />
            </Route>
                )}
                         {isAdmin && (
            <Route exact path={this.props.match.url + "/messages"}>
              <TriviaMessages
                updateTrivvyLinkedRewards={rewardUpdatedDataForTrivvy}
                trivvyOpen={this.state.triviaModalOpen}
                setTrivvyOpen={(v) => this.setState({ triviaModalOpen: v })}
                isAdmin={isAdmin}
                {...this.props}
              />
            </Route>
                   )}
            
            {!isAdmin && (
            <Route exact path={this.props.match.url + "/my-surveys"}>
               <MyPendingTrivvys {...this.props} />
            </Route>
            )}

            {!isAdmin && (
            <Route exact path={this.props.match.url + "/my-messages"}>
               <MyMessages {...this.props} />
            </Route>
              )}
            {/* {this.state.hasUserChatAccess && ( */}
              <Route path={this.props.match.url + "/user-chats"}>
                <UserChatsPage {...this.props} />
              </Route>
            {/* )} */}

            {isAdmin && (
              <Route exact path={this.props.match.url + "/kcs-list"}>
                <TriviaKCSList
                  className="trivvy-list-trivvy-container"
                  updateTrivvyLinkedRewards={rewardUpdatedDataForTrivvy}
                  trivvyOpen={this.state.triviaModalOpen}
                  setTrivvyOpen={(v) => this.setState({ triviaModalOpen: v })}
                  {...this.props}
                />
              </Route>
            )}

            {!isAdmin && (
            <Route exact path={this.props.match.url + "/my-knowledge-checks"}>
               <MyKnowledgeChecks {...this.props} />
            </Route>
            )}
            <Route exact path={this.props.match.url + "/library"}>
              <TriviaLibrary {...this.props} />
            </Route>

            {/* <MyTrivia {...this.props} /> */}
            {/* <Route exact path={this.props.match.url + "/pending-trivvys"}>
              <MyPendingTrivvys {...this.props} />
            </Route> */}

            <Route exact path={this.props.match.url + "/breaking-news"}>
              <TriviaBreakingNewsTab {...this.props} />
            </Route>

            {/* <Route exact path={this.props.match.url + "/rewards"}>
              <TriviaRewards {...this.props} />
            </Route> */}

            <Redirect
              from="*"
              to={
                isAdmin
                  ? this.props.match.url + "/breaking-news"
                  : this.props.match.url + "/library"
              }
            />
          </Switch>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    rewardModalOpen: state.trivia.rewardModalOpenGlob,
    rewardModalPreselectedTrivvys:
      state.trivia.rewardModalPreselectedTrivys || [],
    TriviaBreakingNews: state.trivia.TriviaBreakingNews,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    //updateNavBar: header => dispatch(actionCreators.navBarUpdate(header)),
    orgChangeSuccess: (data) => dispatch(actionCreators.orgChangeSuccess(data)),
    handleGlobalRewardModal: (data) =>
      dispatch(actionCreators.handleGlobalRewardModal(data)),
    setCreateModalState: (data) =>
      dispatch(actionCreators.setCreateModalState(data)),
    updateUserSuccess: (data) =>
      dispatch(actionCreators.updateUserSuccess(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Loading(TriviaContainer, axios));
